export enum AssetCategory {
  Print = 'print',
  Embroidery = 'embroidery',
}

export interface AssetGetRequest {
  clientId: string;
  categoryUids: AssetCategory[];
  ids?: string[];
  limit?: number;
  offset?: number;
}

export interface AssetCreateRequest {
  fileUrl: string;
  clientId?: string;
  storeId?: string;
}
